import React, { Component } from 'react';
import styled from 'styled-components';
import Autosuggest from 'react-autosuggest';
import { TagPicker } from 'prospect-path-components';
import fuzzysearch from 'fuzzysearch';

const AutosuggestWrapper = styled.div`
  display: flex;
  flex: 1;

  .react-autosuggest__container {
    display: flex;
    flex: 1;
  }

  .react-autosuggest__suggestions-list {
    padding: 0;
    margin: 0;
    position: absolute;
    list-style-type: none;
    background: #fff;
    left: 0;
    width: 100%;
    top: 100%;
    border: 1px solid #cbcbcb;
    z-index: 10;
    border-radius: 0 0 7px 7px;
  }

  .react-autosuggest__suggestion--highlighted {
    background: #04C5DC;
    cursor: pointer;
    
    span {
      color: #fff;
    }
  }

  .react-autosuggest__suggestion {
    padding: 0.5rem;
    color: #191919;
    font-family: "Cerebri Sans", sans-serif;

    &:last-child {
      border-radius: 0 0 6px 6px;
    }
  }
`;

export default class AutosuggestTagPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
    };

    this.autocompleteRenderInput = this.autocompleteRenderInput.bind(this);
    this.filterSuggestions = this.filterSuggestions.bind(this);
  }
  getSuggestions(value) {
    const inputValue = value.trim().toLowerCase();
    const valueIds = this.props.value.map(value => value.id);

    return this.props.suggestions
      .filter(suggestion => !valueIds.includes(suggestion.id))
      .filter(suggestion => fuzzysearch(inputValue, suggestion.name.toLowerCase()));
  }
  filterSuggestions({ value, reason }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }
  autocompleteRenderInput({ addTag, ...props }) {
    const handleOnChange = (e, { newValue, method }) => {
      if (method === 'enter') {
        e.preventDefault();
      }

      props.onChange(e);
    };

    return (
      <AutosuggestWrapper>
        <Autosuggest
          ref={props.ref}
          suggestions={this.state.suggestions}
          getSuggestionValue={suggestion => suggestion.id.toString()}
          renderSuggestion={suggestion => <span>{suggestion.name}</span>}
          inputProps={{ ...props, onChange: handleOnChange }}
          highlightFirstSuggestion
          shouldRenderSuggestions={(value) => {
            if (value === undefined) {
              return false;
            }

            return value && value.toString().trim().length >= 2;
          }}
          onSuggestionSelected={(e, other) => {
            console.log(other);
            addTag(other.suggestion);
          }}
          onSuggestionsClearRequested={() => {}}
          onSuggestionsFetchRequested={this.filterSuggestions}
        />
      </AutosuggestWrapper>
    );
  }
  render() {
    return (
      <TagPicker renderInput={this.autocompleteRenderInput} {...this.props} />
    );
  }
}
